// src/Pages/DashboardManagment/VendorRouter.jsx
import React, { useMemo, useState, useEffect } from "react";
import { MODULE_COMPONENTS } from "./moduleMap";
import DefaultDashboard from "./DefaultDashboard";
import AdminDashboard from "./AdminDashboard";
const TAB_META = {
  "Lead Management":     { label: "CRM",         icon: "🎯", order: 1 },
  "inventoryManagement": { label: "Inventory",   icon: "📦", order: 2 },
  "staff-management":    { label: "Employees",   icon: "👥", order: 3 },
  "chat":                { label: "Chat",        icon: "💬", order: 10 },
  "reminder":            { label: "Reminders",   icon: "🔔", order: 11 },
  "meeting":             { label: "Meetings",    icon: "📅", order: 12 },
  "enquiry":             { label: "Enquiries",   icon: "📩", order: 13 },
  "calendar":            { label: "Calendar",    icon: "🗓️", order: 14 },
  "leave":               { label: "Leave",       icon: "🏖️", order: 15 },
  "bulk-sms":            { label: "Bulk SMS",    icon: "📨", order: 20 },
  "rcs":                 { label: "RCS",         icon: "💎", order: 21 },
  "hrms":                { label: "HRMS",        icon: "🏢", order: 30 },
  "amc":                 { label: "AMC",         icon: "📋", order: 40 },
  "paymentlsit":         { label: "Payments",    icon: "💳", order: 50 },
  "paymentgatway":       { label: "Gateway",     icon: "⚡", order: 51 },
  "apiProvider":         { label: "API",         icon: "🔌", order: 60 },
  "cloud&devops":        { label: "DevOps",      icon: "☁️", order: 61 },
  "content-setting":     { label: "Settings",    icon: "⚙️", order: 70 },
};

const VendorTabs = ({ tabs, active, onChange }) => (
  <div className="vendor-tabs-bar">
    <div className="vendor-tabs-inner">
      {tabs.map((t) => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={`vendor-tab-btn ${active === t.key ? "active" : ""}`}
        >
          <span className="vendor-tab-icon">{t.icon}</span>
          <span className="vendor-tab-label">{t.label}</span>
          <span className="vendor-tab-glow" />
        </button>
      ))}
    </div>
  </div>
);

/* ============================================================
   VendorRouter — Main
   ============================================================ */
const VendorRouter = ({ permissions }) => {
  const allowedMenus = permissions?.allowedMenus || [];

  /* Tabs banao */
  const tabs = useMemo(() => {
    const list = [];
    allowedMenus.forEach((menuId) => {
      const meta = TAB_META[menuId];
      if (meta) {
        list.push({
          key: menuId,
          label: meta.label,
          icon: meta.icon,
          order: meta.order,
        });
      }
    });
    return list.sort((a, b) => a.order - b.order);
  }, [allowedMenus]);

  // const [activeTab, setActiveTab] = useState(tabs[0]?.key || null);

const [activeTab, setActiveTab] = useState(
  tabs.find((t) => t.key === "Lead Management")?.key || tabs[0]?.key || null
);
  useEffect(() => {
    if (!tabs.find((t) => t.key === activeTab)) {
      setActiveTab(tabs[0]?.key || null);
    }
  }, [tabs, activeTab]);

  if (!tabs.length) {
    return <DefaultDashboard />;
  }

return (
    <div className="vendor-router-wrapper">
      <div className="vendor-modules-section">
        {tabs.length > 1 && (
          <VendorTabs
            tabs={tabs}
            active={activeTab}
            onChange={setActiveTab}
          />
        )}

        <div className="vendor-module-content">
          {renderTab(activeTab, permissions)}
        </div>
      </div>

      <div className="vendor-dashed-divider" />
      <DefaultDashboard />
    </div>
  );
};

function renderTab(key, permissions) {
  if (key === "Lead Management") return <AdminDashboard />;
  const Component = MODULE_COMPONENTS[key];
  if (Component) return <Component permissions={permissions} />;
  return <DefaultDashboard />;
}

export default VendorRouter;